import { render, staticRenderFns } from "./AllReturns.vue?vue&type=template&id=2547bc57&scoped=true"
import script from "./AllReturns.vue?vue&type=script&lang=js"
export * from "./AllReturns.vue?vue&type=script&lang=js"
import style0 from "./AllReturns.vue?vue&type=style&index=0&id=2547bc57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547bc57",
  null
  
)

export default component.exports